import { createClient } from '@supabase/supabase-js';

export const supabase = createClient(
  'https://ggeeqexormqnazwxzbsy.supabase.co',
  'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImdnZWVxZXhvcm1xbmF6d3h6YnN5Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3Nzk1OTk0ODAsImV4cCI6MjA5NTE3NTQ4MH0.9yLlP94KArsxw8qNqLsLsrErG03djcqJkJPEqtUhOl0',
  {
    auth: {
      storageKey: 'web3kurzus-auth',
      autoRefreshToken: true,
      persistSession: true,
      flowType: 'implicit',
      detectSessionInUrl: true,
    }
  }
);
